import { render, staticRenderFns } from "./MonitorFeeSetting.vue?vue&type=template&id=bdb4a45a&scoped=true"
import script from "./MonitorFeeSetting.vue?vue&type=script&lang=js"
export * from "./MonitorFeeSetting.vue?vue&type=script&lang=js"
import style0 from "./MonitorFeeSetting.vue?vue&type=style&index=0&id=bdb4a45a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb4a45a",
  null
  
)

export default component.exports